import { useCallback, useEffect, useState } from "react";
import * as service from "../services/socialSecurityApi"
import { useDispatch, useSelector } from "react-redux";
import { setHospital, setIsLoading, setNationality, setSocialSecurityNo, setRegistrationDocument, setReasonForSsoDocument, } from "../slices/socialSecuritySlice";
import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";



function useEmployeeSalarySocialSecurity() {
  const dispatch = useDispatch();
  const currentCompany = useSelector((state) => state.company.currentCompany)
  const currentEmployee = useSelector((state) => state.company.currentEmployee)
  const socialSecurityNo = useSelector((state) => state.socialSecurity.socialSecurityNo)
  const [isModalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation();

  const { id } = useParams();

  const updateSocialSecurity = useCallback(
    async (values) => {
      try {
        console.log("update ", values);
        const request = {
          ...values,
          companyId: currentCompany,
          employeeId: id,
          actionId: currentEmployee,
          deliverSocialSecurity: values.deliverSocialSecurity ? 'Y' : 'N',
          hospital: values.hospital,
          hospitalId: values.hospitalId,
          socialSecurityNo: values.socialSecurityNo,
          registrationDocumentId: values.registrationDocument,
          nationalityId: values.nationality,
          ssoReceivedDate: values.ssoReceivedDate,
          reasonForSSOResignationId: values.reasonForSSOResignation,
          remark: values.remark,
          setSocialSecurityBranchForThisEmployee: values.setSocialSecurityBranchForThisEmployee ? 'Y' : 'N',
          branchOfSSOId: values.branchOfSSO || "0",
          setFrom20AForThisEmployee: values.setFrom20AForThisEmployee ? 'Y' : 'N',
          businessCode: values.businessCode || "0",
          insurancePersonContributionRate: values.insurancePersonContributionRate || "0",
        };
        await service.updateSocialSecurity(request);
        message.success(t("common.success"))
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    }, [currentCompany, currentEmployee, dispatch]
  );

  const onSubmit = useCallback(
    (values) => {
      try {
        dispatch(setIsLoading(true));
        Modal.confirm({
          title: t("dialog.confirmation.header"),
          content: (
            <>
              <p>{t('generaInfo.are-you-sure-confirm-to-edit')}</p>
            </>
          ),

          onOk() {
            updateSocialSecurity(values);
            console.log("test ", values);
          },
          onCancel() {
            dispatch(setIsLoading(false));
          },
          okText: t("common.confirm"),
          cancelText: t("common.cancel"),
        });
      } catch (error) {
        console.log(error);
        dispatch(setIsLoading(false));
      }
    },
    [dispatch, updateSocialSecurity]
  );


  const onCancel = useCallback(() => {

    setModalOpen(false);
  }, []);


  const getReasonForSsoDocument = useCallback(
    async () => {
      try {
        const respReasonForSsoDocument = await service.getReasonForSsoDocument({
          groupType: "REASON_FOR_SSO_RESIGNATION"
        });
        // console.log("getReasonForSsoDocument = aaaaa", respReasonForSsoDocument?.data);
        dispatch(setReasonForSsoDocument(respReasonForSsoDocument?.data))

      } catch (error) {
        console.log(error);
      } finally {
        dispatch(setIsLoading(false))
      }
    }, [currentCompany, dispatch]

  )

  const getRegistrationDocument = useCallback(
    async () => {
      try {
        const respRegistrationDocument = await service.getRegistrationDocument({
          groupType: "REGISTRATION_DOCUMENT"
        });
        // console.log("getRegistrationDocument = ", respRegistrationDocument?.data);
        dispatch(setRegistrationDocument(respRegistrationDocument?.data))

      } catch (error) {
        console.log(error);
      } finally {
        dispatch(setIsLoading(false))
      }
    }, [currentCompany, dispatch]

  )

  const getSocialSecurity = useCallback(
    async () => {
      try {
        const respSocialSecurity = await service.getSocialSecurity({
          companyId: currentCompany,
          requestId: "ewfwefewfwe",
          employeeId: id,
          actionId: currentEmployee
        });
        // console.log("SocialSecurity มีไรบ้าง = ", respSocialSecurity?.data?.socialSecurity);
        dispatch(setSocialSecurityNo(respSocialSecurity?.data?.socialSecurity))

      } catch (error) {
        console.log(error);
      } finally {
        dispatch(setIsLoading(false))
      }
    }, [currentCompany, dispatch]

  )

  const getNationality = useCallback(
    async () => {
      try {
        const respNationality = await service.getNationality({
          companyId: currentCompany,
          employeeId: id,
          actionId: currentEmployee
        })
        dispatch(setNationality(respNationality?.data))

      } catch (error) {
        console.log(error);
      } finally {
        dispatch(setIsLoading(false))
      }
    }, [currentCompany, dispatch]
  )

  const getHospital = useCallback(
    async () => {
      try {
        const respHospital = await service.getHospital({
          companyId: currentCompany,
          employeeId: id,
          actionId: currentEmployee
        });
        console.log("Hospital", respHospital);
        dispatch(setHospital(respHospital?.data))
      } catch (error) {
        console.log(error);
      } finally {
        dispatch(setIsLoading(false))
      }
    }, [currentCompany, dispatch])

  useEffect(() => {
    getHospital()
    getNationality()
    getSocialSecurity()
    getRegistrationDocument()
    getReasonForSsoDocument()
  }, []);

  return {
    onSubmit,
    onCancel
  }

}


export default useEmployeeSalarySocialSecurity;